import { SigningModalType } from '../../utils/signing/modalType';
import { SigningIntentionType } from '../../utils/signing/signingIntentionType';
import { inBusinessExperience } from '../../utils/business';
import { isClient } from '../../utils/isClient';
import signingModalManager from '../../utils/signingModalManager';
import { validateIdentificationModalOptions } from '../../utils/validateIdentificationModalOptions';
import { TriggerType } from '../../utils/types/triggerType';
import { businessOpenSignIn, businessOpenSignUp } from './business';

/**
 * @param {Object} signingModalType - The signing modal type at action.
 */
const calculateSigningModalType = (signingModalType) => inBusinessExperience()
    ? signingModalType
    : SigningModalType.identification;

export const triggerSignUp = async(params = {}) =>
{
    const { modalOptions = {}, biEnrichmentParams = {} } = params;

    if (inBusinessExperience()) {
        await businessOpenSignUp(params);
        return;
    }

    return triggerSigningFlow({
        signingModalType: SigningModalType.signUp,
        modalOptions: {
            ...modalOptions,
            intention: SigningIntentionType.signUp
        },
        biEnrichmentParams
    });
};

export const triggerSignIn = async(params = {}) =>
{
    const { modalOptions = {}, biEnrichmentParams = {} } = params;

    if (inBusinessExperience()) {
        await businessOpenSignIn(params);
        return;
    }

    return triggerSigningFlow({
        signingModalType: SigningModalType.signIn,
        modalOptions: {
            ...modalOptions,
            intention: SigningIntentionType.signIn
        },
        biEnrichmentParams
    });
};

export const triggerIdentification = ({ modalOptions = {}, biEnrichmentParams = {} } = {}) =>
    triggerSigningFlow({
        signingModalType: SigningModalType.identification,
        modalOptions,
        biEnrichmentParams
    });

export const triggerSignInForBlockedAction = ({ modalOptions = {}, biEnrichmentParams = {} } = {}) => triggerSignIn({
    modalOptions: {
        ...modalOptions,
        triggerType: TriggerType.BLOCKED
    },
    biEnrichmentParams
});

export const triggerSignUpForBlockedAction = ({ modalOptions = {}, biEnrichmentParams = {} } = {}) => triggerSignUp({
    modalOptions: {
        ...modalOptions,
        triggerType: TriggerType.BLOCKED
    },
    biEnrichmentParams
});

export const triggerIdentificationForBlockedAction = ({ modalOptions = {}, biEnrichmentParams = {} } = {}) => triggerIdentification({
    modalOptions: {
        ...modalOptions,
        triggerType: TriggerType.BLOCKED
    },
    biEnrichmentParams
});

export const triggerSigningFlow = async({
    signingModalType,
    modalOptions = {},
    biEnrichmentParams = {}
}) => {
    if (!isClient()) {
        return;
    }

    validateIdentificationModalOptions(modalOptions);
    return signingModalManager.trigger(calculateSigningModalType(signingModalType), modalOptions, biEnrichmentParams);
};

export const closeSignUp = () => closeSigningFlow(SigningModalType.signUp);

export const closeSignIn = () => closeSigningFlow(SigningModalType.signIn);

export const closeIdentification = () => closeSigningFlow(SigningModalType.identification);

export const closeSigningFlow = (signingModalType) => signingModalManager.close(calculateSigningModalType(signingModalType));
